import React from 'react'
import {wrapper, content} from './TextInCircle.module.scss'
import Circle from './circle.inline.svg'
interface Props {
  fontSize: number
  children: React.ReactNode
}

const TextInCircle = ({fontSize, children}: Props) => (
  <div className={wrapper} style={{fontSize: `${fontSize}rem`}}>
    <Circle />
    <div className={content}>{children}</div>
  </div>
)

export default TextInCircle
